import { Platform } from "react-native";
import notifee, { AndroidImportance, AndroidStyle, EventType } from "@notifee/react-native";
import { useDeeplinkStore } from "../store/deeplinkStore";

// Lazy import to avoid breaking web bundling
let messaging: any = null;

async function getMessaging() {
    if (Platform.OS === "web") return null;

    if (!messaging) {
        const mod = await import("@react-native-firebase/messaging");
        messaging = mod.default;
    }
    return messaging;
}

//
// ✅ Create channel (safe to call multiple times)
//
export async function setupNotificationChannel() {
    if (Platform.OS === "web") return;

    await notifee.createChannel({
        id: "default",
        name: "Default",
        importance: AndroidImportance.HIGH,
    });
}

//
// ✅ Unified renderer used everywhere
//
export async function showNotification(remoteMessage: any) {
    console.log("showNotification:", remoteMessage);
    
    if (!remoteMessage) return;

    const title = remoteMessage?.notification?.title;
    const body = remoteMessage?.notification?.body;

    const image =
        remoteMessage?.notification?.android?.imageUrl ??
        remoteMessage?.data?.image;

    await notifee.displayNotification({
        title,
        body,
        data: remoteMessage?.notification?.data || remoteMessage?.data,
        android: {
            channelId: "default",
            color: "#8F3E47",
            smallIcon: "ic_launcher",
            importance: AndroidImportance.HIGH,
            largeIcon: "ic_launcher_round",
            pressAction: { id: "default" },
            style: image
                ? {
                    type: AndroidStyle.BIGPICTURE,
                    picture: image,
                }
                : undefined,
        },
    });
}

//
// ✅ Permissions + token
//
export async function initNotifications(onToken: (token: string) => Promise<any>) {
    const msg = await getMessaging();
    if (!msg) return;

    try {
        await notifee.requestPermission();
        await msg().requestPermission();

        const token = await msg().getToken();
        if (token) await onToken(token);

        msg().onTokenRefresh(onToken);
    } catch (e) {
        console.warn("Notification init failed:", e);
    }
}

//
// ✅ Foreground listener
//
export async function listenForeground(handler: (message: any) => void) {
    const msg = await getMessaging();
    if (!msg) return () => { };

    return msg().onMessage(handler);
}

//
// ✅ Opened from notification
//
export async function listenNotificationOpen(handler: (message: any) => void) {
    const msg = await getMessaging();
    if (!msg) return () => { };

    const unsubscribe = msg().onNotificationOpenedApp(handler);

    const initial = await msg().getInitialNotification();
    if (initial) handler(initial);

    return unsubscribe;
}
export async function notificationClicked(event: { type: any; detail: any; }){
    const { type, detail } = event;
    console.log("notificationClicked:", detail);
    if (type === EventType.PRESS) {
      const link = detail.notification?.data?.link || detail?.data?.link;
      console.log("notificationClicked with link:", link);
      
      if (typeof link === "string") {
        useDeeplinkStore.getState().pushUrl(link);
      }
    }
  }